export default "__VITE_ASSET__682668d7__"